import { useMutation, useQueryClient } from '@tanstack/react-query';
import { emailAdminService } from '@/services/emailAdminService';
import type { EmailSmtpConfig, EmailSmtpConfigInput } from '@/types/emailAdmin';
import { queryKeys } from '@/lib/queryKeys';

export const useSaveSmtpConfig = () => {
  const queryClient = useQueryClient();
  return useMutation<EmailSmtpConfig, unknown, EmailSmtpConfigInput>({
    mutationFn: (input) => emailAdminService.upsertSmtpConfig(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.notifications.emailAdmin.smtpConfig(),
      });
    },
  });
};
